export const content = {
  company: {
    name: 'Hatch Painting Co.',
    wordmark: 'HATCH PAINTING',
    phone: '(480) 369-5077',
    roc: 'ROC 350211',
    tagline: 'Painting and Renovation You Can Trust.',
  },
  nav: [
    { label: 'Home', href: '#home' },
    { label: 'About', href: '#about' },
    { label: 'Services', href: '#services' },
    { label: 'Gallery', href: '#gallery' },
    { label: 'Reviews', href: '#reviews' },
    { label: 'Contact', href: '#contact' },
  ],
  hero: {
    headline: 'Painting and Renovation You Can Trust.',
    subheadline:
      'Expert interior painting, exterior painting, and renovation with reliable, lasting results for homes and businesses across Gilbert and the East Valley.',
    primaryCTA: 'Get a Free Estimate',
    secondaryCTA: 'Explore Our Services',
    trustStrip: 'Licensed, Bonded and Insured. ROC 350211',
  },
  trustBar: [
    'Licensed, Bonded and Insured',
    'Guaranteed Craftsmanship',
    'Family Owned and Locally Trusted',
  ],
  whyHatch: {
    heading: 'The Hatch Difference',
    intro:
      'From your first consultation to the final brush stroke, we keep you involved every step of the way.',
    benefits: [
      { title: 'Expertise and Efficiency', icon: 'award' },
      { title: 'Reliable Service', icon: 'clock' },
      { title: 'Transparent Pricing', icon: 'file-text' },
      { title: 'Premium Materials', icon: 'droplet' },
      { title: 'Attention to Detail', icon: 'search' },
      { title: 'Flexible Scheduling', icon: 'calendar' },
    ],
  },
  services: {
    heading: 'Our Services',
    subhead:
      'Professional painting and renovation solutions designed to transform, protect, and enhance your space.',
    items: [
      {
        title: 'Interior Painting',
        description:
          'Smooth, flawless finishes and vibrant, lasting color for walls, ceilings, trim, and cabinets.',
        subServices: [
          'Walls',
          'Ceilings',
          'Doors',
          'Trim and baseboards',
          'Drywall repair',
          'Cabinet refinishing',
          'Wood staining',
        ],
        image:
          'https://cdn.magicpatterns.com/uploads/gHBjBj76vXVPbHktvkvmfc/476452161_17896062234148706_162521529730352368_n.jpg',
        icon: 'home',
      },
      {
        title: 'Exterior Painting',
        description:
          "Durable, high-quality finishes built to withstand Arizona's harsh climate and boost curb appeal.",
        subServices: [
          'Stucco',
          'Wood siding',
          'Fascia and eaves',
          'Doors and windows',
          'Block walls',
          'Deck and fence staining',
        ],
        image:
          'https://cdn.magicpatterns.com/uploads/7ye3W7r6vsGXN9z5i3cGXQ/546524638_17921494851148706_5237966123234028114_n.jpg',
        icon: 'sun',
      },
      {
        title: 'Renovation Services',
        description:
          'From kitchen and bathroom remodels to fresh layouts, craftsmanship that adds lasting value.',
        subServices: [
          'Kitchen remodels',
          'Bathroom remodels',
          'Flooring installation',
          'Custom carpentry',
          'Fixture updates',
        ],
        image:
          'https://cdn.magicpatterns.com/uploads/uWcmbvmocUQVbM9uLtuT2g/466498985_17885100888148706_5677758887054032892_n.jpg',
        icon: 'hammer',
      },
    ],
  },
  signatureCallout: {
    headline: 'Every Exterior Project Starts With a Detailed Pressure Wash.',
    body: 'A clean, properly prepped surface is the difference between paint that looks good today and a finish that lasts for years. It is how we guarantee a lasting result.',
    specialty:
      'Skilled in stucco, limewash, and specialty finishes most painters will not touch.',
  },
  process: {
    heading: 'How It Works',
    subhead: 'A clear, step-by-step process that makes your project seamless.',
    steps: [
      {
        title: 'Request Your Free Estimate',
        description:
          'We assess your project, answer questions, and provide clear, upfront pricing.',
      },
      {
        title: 'Personalized Project Plan',
        description:
          'A detailed plan tailored to your vision, timeline, and budget.',
      },
      {
        title: 'Exceptional Results That Last',
        description:
          'Skilled craftsmanship and durable finishes that protect your property for years.',
      },
    ],
  },
  serviceAreas: {
    heading: 'Serving Arizona Communities With Pride',
    body: 'Wherever you are in the East Valley, Hatch Painting is your go-to partner for painting done right.',
    areas: [
      'Gilbert',
      'Queen Creek',
      'San Tan Valley',
      'Chandler',
      'Mesa',
      'Apache Junction',
      'Tempe',
      'Scottsdale',
    ],
  },
  reviews: {
    heading: 'What Your Neighbors Are Saying',
    items: [
      {
        name: 'Samantha Hoeft',
        quote:
          "Hatch Painting did an amazing job. Preston had very clear communication, was super easy to work with, and was clear on what was offered. The invoicing and payment was seamless. I wasn't even in town when our house was painted and there were no issues. Highly recommend.",
      },
      {
        name: 'Stephanie Stasik',
        quote:
          'From start to finish, Preston Hatch and his crew set out to earn and keep our business for life. The color match, completed paint job, attention to the smallest detail, and final walk-through were all outstanding. You will not regret choosing Hatch Painting.',
      },
      {
        name: 'A S',
        quote:
          'After speaking with a few contractors, we chose Hatch Painting. Their method for the best stucco coverage made so much sense and was not proposed by anyone else, their quote was very reasonable, and they had limewash experience others did not. Extremely pleased with their work and customer service.',
      },
      {
        name: 'Natalie Smith',
        quote:
          'Preston did a full interior and exterior remodel for us and was amazing to work with. The before and after speaks for itself.',
      },
      {
        name: 'Dale Matsukawa',
        quote:
          'Hatch Painting painted the exterior of our home and did an excellent job. The house looks awesome. Preston made sure all our concerns were addressed.',
      },
    ],
  },
  contact: {
    heading: 'Ready to Refresh Your Space?',
    subhead: 'Get a free, no-obligation estimate today.',
    services: [
      'Residential Interior Painting',
      'Residential Exterior Painting',
      'Residential Renovation',
      'Commercial Interior Painting',
      'Commercial Exterior Painting',
      'Commercial Renovation',
    ],
  },
}
